import React, { useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import CBAccordion from '@cb/apricot/CBAccordion';
import cn from 'classnames';
import { useUID } from 'react-uid';
export const linkPosition = ['top', 'bottom'];
export const Expandable = ({ children, defaultOpen = false, extendFocusableElements, className, classNameHeader, classNamePanel, classNameContent, offScreen, ariaLabelledbyID, closedLabel = 'See More', openLabel = 'See Less', linkPosition: linkPos = 'bottom', title, triggerId, panelId, panelOverlay, 
// animation = true,
heightAdjustment, onChange, }) => {
    const triggerRef = useRef(null);
    const panelRef = useRef(null);
    const uid = useUID();
    const elementId = panelId || `pnl_${uid}`;
    /**
     * On Expandable state change handler
     * @param panelEl
     */
    const onChangeCallBack = panelEl => {
        onChange && onChange(panelEl.classList.contains('cb-in'));
    };
    useEffect(() => {
        CBAccordion({
            elem: triggerRef.current,
            targetElem: panelRef.current,
            triggerLabel: ReactDOMServer.renderToString(React.createElement(React.Fragment, null, closedLabel)),
            triggerLabelActive: ReactDOMServer.renderToString(React.createElement(React.Fragment, null, openLabel)),
            onChange: onChangeCallBack,
            animation: false,
            heightAdjustment,
            extendFocusableElements,
        });
    }, [linkPos]);
    const getPosition = (position) => {
        switch (position) {
            case 'top':
                return 'top';
            case 'bottom':
            default:
                return 'bottom';
        }
    };
    const triggerLink = () => {
        return (React.createElement("a", { href: "/#", className: cn('cb-link-blue cb-accordion-trigger', className), ref: triggerRef, id: triggerId, role: "button" },
            typeof openLabel === 'string' && typeof closedLabel === 'string' && (React.createElement("span", null, defaultOpen ? openLabel : closedLabel)),
            (typeof openLabel !== 'string' || typeof closedLabel !== 'string') &&
                (defaultOpen ? openLabel : closedLabel),
            React.createElement("div", { className: "cb-accordion-icon cb-margin-left-8" },
                React.createElement("span", { className: "line top" }),
                React.createElement("span", { className: "line bottom" }))));
    };
    return (React.createElement(React.Fragment, null,
        getPosition(linkPos) === 'top' && triggerLink(),
        React.createElement("div", { className: cn('cb-accordion-trigger-panel transition', panelOverlay && 'cb-accordion-panel-overflow', defaultOpen && 'cb-in', classNamePanel), "aria-label": offScreen || undefined, "aria-labelledby": ariaLabelledbyID || undefined, role: "region", ref: panelRef, id: elementId, "data-cbtrack-comp": "apricot-react:accordion" },
            title && React.createElement("div", { className: cn('cb-accordion-heading-title', classNameHeader) }, title),
            React.createElement("div", { className: cn('cb-accordion-panel-content', classNameContent) }, children)),
        getPosition(linkPos) === 'bottom' && triggerLink()));
};
//# sourceMappingURL=Expandable.js.map